import { useQuery } from "@tanstack/react-query";
import { getRevenueEachMonthApi } from "../../services";
import { useAccountStore, useRevenueEachMonth } from "../../store";

export const useGetRevenueEachMonthApi = () => {
  const { accountId, year } = useRevenueEachMonth();
  const { info } = useAccountStore();
  const { data, isLoading } = useQuery({
    queryKey: ["revenue-revenue-each-month", year, info?.role],
    queryFn: () => getRevenueEachMonthApi(year, info?.role === "ROLE_INVERTOR" ? accountId : undefined),
    enabled: !!year && !!info?.role,
  });
  return {
    revenueEachMonth: data,
    isLoading,
  };
};
